import { DateTimeHelper } from 'src/app/core/helper/datetime.helper';
import { PrizeStatus, PrizeType } from './raffle-rocket.enums';

export class Prize {
    prizeId: number;
    raffleId: number;
    name: string;
    description: string;
    category: string;
    image1Path: string;
    image2Path: string;
    image3Path: string;
    image4Path: string;
    drawDate: string | null;
    value: number;
    drawnBy: number | null;
    voidReason: string;
    drawnOn: string | null;
    winningTicketId: number | null;
    purchaseId: number | null;
    prizeType: PrizeType;
    status: PrizeStatus;
    winningNumber: string;
    winnerName: string;
    salesEnd: string;
    sortOrder: number;
    endFmt: string;
    drawFmt: string;

    isEarlyBird = false;
    isSalesOver = false;

    public constructor(init?: Partial<Prize>) {
        Object.assign(this, init);

        if (this.drawDate != null) {
            if (!this.drawDate.endsWith('Z')) { this.drawDate = this.drawDate + 'Z'; }
            this.drawFmt = DateTimeHelper.formatDate(this.drawDate, false, false);
            this.drawFmt = this.drawFmt.slice(-5) === '12 AM' ? this.drawFmt.slice(0, -8) : this.drawFmt;
        }
        if (this.salesEnd != null) {
            if (!this.salesEnd.endsWith('Z')) { this.salesEnd = this.salesEnd + 'Z'; }
            this.endFmt = DateTimeHelper.formatDate(this.salesEnd, false, false);
            this.endFmt = this.endFmt.slice(-5) === '12 AM' ? this.endFmt.slice(0, -8) : this.endFmt;

            if (new Date(this.salesEnd) < new Date()) {
                this.isSalesOver = true;
            }
        }
    }
}
